<script>
	/**
	 * This top-level route serves as a 404 page.
	 */

	module.exports = {
		props: ['on-ready'],
		mounted() {
			setTimeout(() => {
				this.$emit('data-ready');
			}, 0);

			// send ready notice to parent
			if (typeof this.onReady === 'function') {
				this.onReady();
			}
		}
	};
</script>
<template>
	<main
		id="content"
		class="main"
		role="main">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Page Not Found</h1>
			</div>
		</header>
		<div class="main-content wrapper rte">
			<p>The Page you are looking for cannot be found. (Error 404)</p>
		</div>
	</main>
</template>
